import Head from "next/head";

import { MemoizedFooter } from "../src/layouts/footer";
import { MemoizedHeader } from "../src/layouts/header";
import AboutUs from "../src/pages/AboutUs";
import Breadcrumbs from "../src/components/common/Breadcrumbs";
import { Box } from "@mui/material";

export default function Aboutus() {
  const BREADCRUMB_ITEMS = [
    { label: "Home", href: "/" },
    { label: "About Us" },
  ];

  const BREADCRUMB_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.turno.club/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "About Us",
        item: "https://www.turno.club/aboutus",
      },
    ],
  };

  return (
    <>
      <Head>
        <title>
          Turno.club - India &apos; s top electric cargo vehicle selling
          platform
        </title>
        <meta
          name="description"
          content="Turno is best place to buy an electric three-wheeler/electric auto in India. Select commercial EV from many brands. Get free test drives, loans and offers."
        />

        <meta
          name="keywords"
          content="Turno, Turno company overview, Turno overview, Turno company information, Turno corporate information, Turno facts, Turno mission, Turno vision"
        />
        <meta name="author" content="Turno" />
        <meta name="url" content="https://www.turno.club/aboutus" />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta property="og:url" content="https://www.turno.club/aboutus" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Turno.club - India ' s top electric cargo vehicle selling platform"
        />
        <meta
          property="og:description"
          content="Turno gives the best solution to buy commercial three wheeler electric loading vehicle or electric auto in India. Get a free test drive and book your electric vehicle today. Turno provide the best loan offer on EV. Varied range of EV available on turno.club with best price in India"
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />
        {/* Twitter */}
        <meta
          name="twitter:description"
          content="Turno gives the best solution to buy commercial three wheeler electric loading vehicle or electric auto in India. Get a free test drive and book your electric vehicle today. Turno provide the best loan offer on EV. Varied range of EV available on turno.club with best price in India"
        />
        <meta
          name="twitter:title"
          content="Turno.club - India ' s top electric cargo vehicle selling platform"
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta name="twitter:url" content="https://www.turno.club/aboutus" />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />

        <link rel="canonical" href="https://www.turno.club/aboutus" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>

      <MemoizedHeader />
      <AboutUs />
      <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
        <Breadcrumbs items={BREADCRUMB_ITEMS} />
      </Box>
      <MemoizedFooter />
    </>
  );
}
